import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { TotalDashboard } from '../../models/total-dashboard.model';

@Injectable({ providedIn: 'root' })
export class TotalDashboardService {

  constructor(private apiService: ApiService) {}

  /**
   * Busca totais gerais consolidados para o cabecalho do dashboard.
   * Endpoint: GET /totaldashboard/total-geral
   */
  getTotalGeral(params: {
    dataHoraInicial?: string;
    dataHoraFinal?: string;
    conta?: number;
  }): Observable<TotalDashboard> {
    const parts: string[] = [];
    if (params.dataHoraInicial) parts.push(`dataHoraInicial=${params.dataHoraInicial}`);
    if (params.dataHoraFinal) parts.push(`dataHoraFinal=${params.dataHoraFinal}`);
    if (params.conta) parts.push(`conta=${params.conta}`);

    const query = parts.length ? `?${parts.join('&')}` : '';
    return this.apiService.read<TotalDashboard>(`/totaldashboard/total-geral${query}`);
  }

  /**
   * Busca totais antigos (array) — mantido para compatibilidade.
   * Endpoint: GET /totaldashboard
   */
  getTotals(dataHoraInicial: string, dataHoraFinal: string): Observable<TotalDashboard[]> {
    const query = `dataHoraInicial=${dataHoraInicial}&dataHoraFinal=${dataHoraFinal}`;
    return this.apiService.read<TotalDashboard[]>(`/totaldashboard?${query}`);
  }

  /**
   * Busca totais por mes para o grafico de linha.
   * Endpoint: GET /totaldashboard/totaisPorMes
   */
  getTotalsPorMes(anoInicio: number, anoFim: number): Observable<TotalDashboard[]> {
    const query = `anoInicio=${anoInicio}&anoFim=${anoFim}`;
    return this.apiService.read<TotalDashboard[]>(`/totaldashboard/totaisPorMes?${query}`);
  }
}
